import React,{ useEffect } from 'react'
import {
    Link,
    useLocation
  } from "react-router-dom";
import './../css/header.css'
import $ from 'jquery'

function LothunMenu() {
    const location = useLocation();

    useEffect(()=>{
        const localPath =  location.pathname.split('/');
        if(localPath[2] == 'win') {
            LinkChk(document.getElementById("win"))
        }else{
            LinkChk(document.getElementById("money"))
        }
    },[])

    const LinkChk = (e)=>{
        $('.nav-link').removeClass('active')
        e.classList.toggle('active')
    }
  return (
    <nav className="navbar navbar-expand py-0 top-menu">
        <div className="container">
                <ul className="navbar-nav page-selector mr-auto">
                    <li className="nav-item mn-main mx-2">
                        <Link className="nav-link active" id="win" to="/lothun/win" onClick={(e)=>LinkChk(e.target)}>ผลรางวัล</Link>
                    </li> 
                    {process.env.REACT_APP_ADMIN_TYPE == 'SA' && <>
                        <li className="nav-item mn-main mx-2" >
                            <Link className="nav-link" id="money" to="/lothun/money" onClick={(e)=>LinkChk(e.target)}>สรุปรวมหวยหุ้น</Link>
                        </li>
                        <li className="nav-item mn-main mx-2" >
                            <Link className="nav-link" id="money" to="/lothun/paymoney" onClick={(e)=>LinkChk(e.target)}>สรุปจ่ายสูงสุด</Link>
                        </li>
                    </> }
                </ul>
        </div>
    </nav>
  )
}

export default LothunMenu